import React from "react";
import PublicApply from "@/components/public/PublicApply";

export default function FranchiseeSignup() {
  return (
    <PublicApply
      role="franchisee"
      roleTestId="franchisee-signup"
      title="Open a Lifted franchise."
      blurb="Take a Lifted Supplies territory in your region. You'll be responsible for partners, drivers, inventory, and local growth. Admin approval, capital review, and signed agreement required."
      extraFields={[
        { key: "territory_city", label: "Target city / territory", placeholder: "Morgantown, WV" },
        { key: "capital_range", label: "Available capital range (USD)", placeholder: "$50k–$150k" },
        { key: "experience", label: "Relevant experience (1 line)", placeholder: "10 years operating retail" },
      ]}
    />
  );
}
